/**
 * TODO: udpate administrationFeesMax, value
const simulationMockup = {
  purpose: {
    index: "18",
    icon: "ct-icon-obiettivo-acquisto-auto",
    text: "Camper",
    code: "CAM",
  },
  amount: {
    current: 15000,
    min: "16994,92",
    max: "18840,60",
  },
  payment: {
    current: 400,
    min: "393,68",
    max: "399,36",
  },
  numberOfInstallments: {
    min: "43",
    max: "47",
  },
  TAN: {
    min: 5.9,
    max: 10.89,
  },
  TAEG: {
    min: 7.21,
    max: 12.59,
  },
  others: {
    transparencyDuty: "0,00",
    administrationFees: "225,00",
    //TODO: use valid data;
    administrationFeesMax: "250,00",
    stampDuty: "16,00",
    //TODO: use valid data;
    stampDutyMax: "32,00",
  }
}
 */


export const simulation = {
  purpose: {
    index: "45",
    icon: "ct-icon-obiettivo-viaggio",
    text: "Spese familiari",
    code: "FAM",
  },
  amount: {
    value: 10000,
    min: 1000,
    max: 30000,
    minAmountDue: 12682.64,
    maxAmountDue: 15048.42,
  },
  payment: {
    value: 175,
    min: 175,
    max: 475,
    minPaymentDue: 152.46,
    maxPaymentDue: 179.96,
  },
  numberOfInstallments: {
    min: 69,
    max: 83,
  },
  TAN: {
    min: 6.90,
    max: 11.89,
  },
  TAEG: {
    min: 7.35,
    max: 13.43,
  },
  others: {
    transparencyDuty: 0,
    administrationFees: 40.00,
    administrationFeesMax: 150.00,
    stampDuty: 25.10,
    stampDutyMax: 25.38,
  }
}

export const simulationOneMinute = {
  purpose: {
    index: '45',
    icon: 'ct-icon-obiettivo-viaggio',
    text: 'Spese familiari',
    code: 'FAM'
  },
  amount: {
    current: 2000,
    min: '2623,63',
    max: '2623,63'
  },
  payment: {
    current: 45,
    min: '44,90',
    max: '44,90'
  },
  numberOfInstallments: {
    min: '57',
    max: '57'
  },
  TAN: {
    min: 9.9,
    max: 9.9
  },
  TAEG: {
    min: 12.52,
    max: 12.52
  },
  others: {
    transparencyDuty: '0,00',
    administrationFees: '35,00',
    stampDuty: '5,09'
  }
}